import { render } from "./ModalAddPessoa.vue?vue&type=template&id=0689c239&scoped=true"
import script from "./ModalAddPessoa.vue?vue&type=script&lang=js"
export * from "./ModalAddPessoa.vue?vue&type=script&lang=js"

import "./ModalAddPessoa.vue?vue&type=style&index=0&id=0689c239&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0689c239"]])

export default __exports__